<template>
  <div class="chat-list">
    <van-search
      v-model="condition"
      placeholder="请输入"
      @search="onSearch"
       show-action
      input-align="center"
    >
      <template #action>
       <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check='true'
      @load="onLoad"
    >
      <div class="item" @click='goContent(item)' v-for="(item, index) in list" :key="index">
        <div class="img-box" v-if="item.chatType == 1">
          <img v-for="(img, i) in item.avatarUrlList " :key="i" class="img-box-avatar" :src='img'>
        </div>
        <img class="item-img" v-else :src='item.avatarUrl'></img>
        <div class="item-mid f1">
          <div class="item-top">
            <div class="c4 omit f1" :class="{'c2': item.roomFlag == 1}">{{item.name}}</div>
              <div class="c9" style="font-size:10px;text-align:right">{{item.latestMessageTime}}</div>
          </div>
          <div  class="item-bot">
            <div class="c9 ft24 omit f1" style="margin-top:10px">{{item.latestMessageContent}}</div>
            <img class="no-notice" v-show="item.messageNoticeType == 1" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/seller/no_notice.png"></img>
          </div>

        </div>
      </div>
    </van-list>
    <!-- <div class="tac c6 ft28" v-if="!list.length && loading != 'loading'" style="margin-top: 100px">暂无数据</div> -->
  </div>
</template>

<script>
import { List } from 'vant';
import { getMessageList } from '@/api/seller'
import { getUserInfo } from '@/api/login'
export default {
  data() {
    return {
      loading: false,
      finished: false,
      pageSize: 40,
      pageNo: 1,
      list: [],
      status: '',
      condition: '',
      query: {},
      timer: null,
      entityType: '',
      userInfo: {},
    }
  },
  computed: {
    pageNumber() {
      return (this.pageNo - 1) * this.pageSize
    }
  },
  mounted() {
    this.query = this.$route.query || {}
    this.entityType = this.query.entityType
    this.listenNewMsg()
    const token = localStorage.getItem('token')
    if(token) {
      this.getUserInfo()
    }

  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    changeTab(item) {
      this.tabValue = item.value
    },
    onLoad() {
      if(this.finished) {
        return
      }
      this.getList()
    },
    // 查询
    onSearch() {
      this.pageSize = 40
      this.pageNo = 1
      this.list = []
      this.status = ''
      this.loading = false
      this.finished = false
      this.getList()
    },
    // 获取数据
		async getList() {
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        condition: this.condition,
        ...this.$route.query,
         entityType: this.entityType,
      }
			/** 如果是业务方 和系统方跳转 type参数 变成 对应角色 */
      if(this.status == 'error' || this.finished || this.status=='empty') {
        this.loading = false
        return
      }
			// this.loading = true
			try {
				const res = await getMessageList(params)
        const { currentEntityType} = res.mdata
        this.loading = false
				/** 判断为空 */
				if (this.pageNo == 1 && !currentEntityType.length) {
					this.list = []
          this.finished = true
          this.status = 'empty'
					return
				}
        this.pageNo++
				this.list = currentEntityType
				/** 判断是否已经加载完毕 */
				if (currentEntityType.length < this.pageSize) {
          this.finished = true
					return
				}

			} catch (error) {
        this.status = 'error'
        this.loading = false
			}
		},
    // 去往聊天内容
    goContent(item) {
      /** 判断是集合 还是展开的列表 */
      // 是展开的用户
      if(item.roomFlag == 1) {
        const params = {
          chatRoomNo: item.chatRoomNo,
          entityType: item.entityType,
          entityNo: item.entityNo
        }
         if(item.entityType == 0) {
          params.entityNo = this.userInfo.number
        }
        if(item.entityType == 2) {
          params.entityNo = -1
        }
        this.$router.push({name: 'chatContent', query: params})
      } else {
        // 点击集合 则重新刷新页面
        this.entityType = item.entityType
        this.status = 'more'
        this.onSearch()
      }
    },
    // 监听新消息
    listenNewMsg() {
      const timerNum = 5 * 1000
      this.timer = setInterval(() => {
        this.pageSize = 40
        this.pageNo = 1
        // this.list = []
        this.finished = false
        this.status =''
        this.getList()
      }, timerNum)
    },
    async getUserInfo() {
      const res = await getUserInfo()
      this.userInfo = res.mdata.user
    }
  },
  components: {
    'van-list': List
  }
}
</script>

<style scoped lang='less'>
.chat-list {
  font-size: 28px;
  color: #222;
}
.tab {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;
  &-item {
    &.active {
      color: #4f51a6;
    }
  }
}
.list {
  margin: 0 10px;
  .item {
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 140px;
    width: 100%;
    box-sizing: border-box;
    &-img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-right: 20px;
    }
    &-mid {
      font-size: 28px;
      overflow: hidden;
    }
    &-bot, &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
    }
    &-bot {
      margin-top: 10px;
    }
    .no-notice {
      width: 30px;
      height: 30px;
    }
  }
}
.img-box  {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-right: 20px;
  background: #ebebeb;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  &-avatar {
    width: 30%;
    height: 30%;
    margin: 0 1%;
  }
}
.c6 {
  color: #666;
}
.c9 {
  color: #999;
}
.tac {
  text-align: center;
}
.c4 {
  color: #4f51a6;
}
.c2 {
  color: #222;
}
.ft24 {
  font-size: 26px;
}
.omit {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.f1 {
  flex: 1;
}
</style>
